import { useEffect, useRef, useState } from "react";
import { cv } from "../data/profile";

type DegreeDocument = (typeof cv.degreeDocuments)[number];

function DegreeDocumentDialog({ degreeDocument, onClose }: { degreeDocument: DegreeDocument; onClose: () => void }) {
  const ref = useRef<HTMLDialogElement>(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const dialog = ref.current!;
    const previous = window.document.activeElement as HTMLElement | null;
    dialog.showModal();
    return () => { dialog.close(); previous?.focus(); };
  }, []);

  return <dialog ref={ref} className={`degree-dialog${expanded ? " degree-dialog-expanded" : ""}`} aria-labelledby="degree-document-title" onCancel={(event) => { event.preventDefault(); onClose(); }}>
    <header>
      <div><span>ISPGAYA · COMPUTER ENGINEERING</span><h2 id="degree-document-title">{degreeDocument.title}</h2></div>
      <div><button type="button" onClick={() => setExpanded(value => !value)}>{expanded ? "Restore" : "Fullscreen"}</button><button type="button" aria-label="Close degree document" onClick={onClose}>×</button></div>
    </header>
    <div><img src={degreeDocument.image} alt={`${degreeDocument.title} issued to Nuno Miranda`} /></div>
  </dialog>;
}

export function DegreeDocuments() {
  const [selected, setSelected] = useState<DegreeDocument | null>(null);
  return <section className="cv-section cv-degree-documents" id="degree-documents" aria-labelledby="degree-documents-heading">
    <div className="cv-section-heading"><div><span className="cv-section-kicker">ACADEMIC CREDENTIAL</span><h2 id="degree-documents-heading">ISPGAYA degree documents</h2></div><span className="cv-certificate-count">3 original pages</span></div>
    <p>Original degree certificate and academic transcript for the Bachelor's degree in Computer Engineering.</p>
    <div className="degree-document-grid">
      {cv.degreeDocuments.map((document) => <article key={document.image}>
        <img src={document.image} alt="" loading="lazy" />
        <div><h3>{document.title}</h3><p>{document.description}</p><button type="button" onClick={() => setSelected(document)} aria-haspopup="dialog">View document <span aria-hidden="true">↗</span></button></div>
      </article>)}
    </div>
    {selected ? <DegreeDocumentDialog degreeDocument={selected} onClose={() => setSelected(null)} /> : null}
  </section>;
}
